export default {
  content: {
    iosPromptPart1: "Zainstaluj aplikację na swoim iPhonie:<br /> stuknij ",
    iosPromptPart2: "a następnie <em>'Dodaj do ekranu początkowego.'</em>",
    bookingStatus: {
      statusNew: {
        label: "Oczekujący",
        desc: " Twoja rezerwacja została pomyślnie wysłana. Potrzebujemy odrobinę czasu, aby ją przejrzeć."
      },
      statusAccept: {
        label: "Zatwierdzony",
        desc: " Wspaniale! Twoja rezerwacja została zatwierdzona.",
        pickupText: "Nasz kierowca będzie na Ciebie czekał przed terminalem lotniska.",
        pickupTextDeparture: "Otrzymasz SMS z przypomnieniem w dniu %time% około 18.00."
      },
      statusReject: {
        label: "Odrzucony",
        desc: " Bardzo nam przykro, niestety musieliśmy odrzucić Twoją rezerwację.",
        moreInfo: "Aby uzyskać więcej informacji",
        contact: "skontaktuj się z nami"
      },
      statusCanceled: {
        label: "Anulowany",
        desc: " Twoja rezerwacja została anulowana. Dziękujemy za informację!",
        moreInfo: "Twoja płatność została zwrócona i powinna być na Twoim koncie w ciągu 10 dni roboczych.",
        infoWithoutRefund: 'Anulujesz mniej niż 8 godzin przed planowanym lotem. Nie otrzymasz zwrotu pieniędzy.',
      },
      statusAssigned: {
        descDeparture: "jest gotowy, by odebrać Cię jutro o",
        descTodayDeparture: "jest gotowy, by odebrać Cię dziś o",
        descNormal: "będzie oczekiwał przed terminalem lotniska.",
        contactInfo: "Możesz skontaktować się z nim",
        desc: " Poznaj swojego kierowcę.",
        label: "Gotowy"
      },
      statusCompleted: {
        desc: " Będziemy bardzo szczęśliwi, jeśli",
        review: 'zostawisz ocenę.',
        tripReview: 'Zostaw ocenę',
        label: "Zakończony",
        allDone: "Gotowe!",
        thanksForReview: 'Dziękujemy za opinię!',
      },
      statusNoShow: {
        moreInfo: "Jeśli anulujesz rezerwację, kierowca zostanie o tym powiadomiony.",
        desc: "(<span><strong>%driver%</strong> czekał na ciebie w umówionym miejscu.</span>)",
        label: "No show"
      },
    },
    layout: {
      header: {
        welcomeMessage: "Cześć! Miło znowu Cię widzieć.",
        registerMessage: "Cześć! Znamy się już?",
        registerSecondMessage: "Nie? W takim razie poznajmy się!",
        registerButton: "Zarejestruj się",
        helloAgainTitle: "Witaj ponownie!",
        logIn: "Zaloguj się",
        activeBookingCount: "<span>Masz </span> %count% nadchodząca rezerwacje"
      },
      landingLayout: {
        title: "Punktualnie i wygodnie",
        desc: "<span>Twoja podróż na lotnisko</span> nigdy nie była prostsza!",
        bookNow: "Zarezerwuj teraz!",
        questionsTitle: "Pytania?",
        poweredByStripe: "Powered by Stripe & iZettle®"
      },
      menuMain: {
        home: "Strona główna",
        booking: "Rezerwacja",
        howItWorks: "Jak to działa",
        pricing: "Cennik",
        faq: "FAQ",
        contact: "Kontakt",
        routeHortenTorp: "Trasa Horten - Torp",
        complaint: "Reklamacje",
      },
      sidebarAndHeader: {
        dashboard: 'Przejazdy',
        booking: 'Rezerwacja',
        myAccount: 'Moje konto',
        help: 'Pomoc',
        editReservation: 'Edytuj rezerwację',
        backToEditTitle: 'Wróć do edycji rezerwacji',
        backToHelpTitle: 'Wróć do Pomoc',
        backToDashboardTitle: 'Wróć do Panelu',
      }
    },
    landing: {
      homepage: {
        mainpage: {
          title: "Oslo, Drammen i Horten",
          subtitleFirst: "Transfery",
          subtitleSecond: "Oslo Torp"
        },
        about: {
          headline: {
            title: "Prosty dojazd na lotnisko",
            description: "Zarezerwuj, jedź i leć!"
          },
          profits: {
            first: {
              title: "Prosta rezerwacja",
              description: "Jedź z nami z Oslo Bussterminal, Drammen Bangeløkka lub z promu Horten na lotnisko Oslo Torp. Szybka i prosta rezerwacja!",
              footer: "Jakieś pytania?",
              linkFaq: {
                preTitle: "Sprawdź nasze",
                title: "FAQ"
              },
              linkContact: {
                separator: " lub ",
                title: "Skontaktuj się z nami"
              }
            },
            second: {
              title: "Dojedź na czas",
              description: "Bus będzie na lotnisku minimum 1,5 godziny przed odlotem. Bus odjeżdża najwcześniej 30 minut po faktycznym przylocie na Torp.",
              footer: "Sprawdź status i wprowadź zmiany w rezerwacji.",
              linkTitle: "Stwórz konto"
            },
            third: {
              title: "Łatwe płatności",
              description: "Wybierasz, jaki sposób płatności jest dla Ciebie najwygodniejszy. Opłaty możesz dokonać online lub gotówką/kartą dopiero u kierowcy. Żadnych ukrytych kosztów, zawsze wiesz, ile zapłacisz.",
              footer: "Ile płacę?",
              linkTitle: "Sprawdź ceny"
            },
          }
        },
        testimonials: {
          title: "Nasi zadowoleni klienci",
          description: "Jedź z nami i dołącz do nich",
          items: {
            first: {
              author: "Thomas F.",
              content: "Przyjazny kierowca i był na czas. Polecam!",
              logoAlt: "Facebook",
              url: "facebook.com"
            },
            second: {
              author: "Katarzyna O.",
              content: "Zarezerwowałam transfer z promu Horten do Oslo Torp. Bus był na czas i łatwo było zarezerwować.",
              logoAlt: "Facebook",
              url: "facebook.com"
            },
            third: {
              author: "Martine S.",
              content: "Dobry, szybki i niezawodny transport do Oslo Torp.",
              logoAlt: "Google",
              url: "google.com"
            },
            fourth: {
              author: "Patryk K.",
              content: "Autobus był w fajny, a kierowca był profesjonalny. Bardzo łatwo było znaleźć autobus na lotnisku. Świetna tańsza alternatywa.",
              logoAlt: "Google",
              url: "google.com"
            }
          },
          footer: {
            title: "Rezenzja z"
          }
        }
      },
      howItWorks: {
        title: "Jak to działa?",
        description: "Jedź z domu, dziel podróż z innymi pasażerami i płać mniej.",
        list: {
          first: {
            title: "Szybka rezerwacja",
            description: "Zarezerwuj bus przez stronę internetową lub zadzwoń do nas. Bus podjedzie gdzie tylko chcesz: pod dom, miejsce pracy lub lotnisko Oslo Torp."
          },
          second: {
            title: "Stały kontakt",
            description: "Jako zarejestrowany użytkownik możesz edytować zamówienie i śledzić jego status. Pozostajemy w kontakcie, dlatego dzień przed wylotem czekaj na SMS potwierdzający godzinę przyjazdu busa."
          },
          third: {
            title: "Pewny transport",
            description: "Jeśli Twój przylot jest opóźniony, nie martwisz się. Kierowca czeka na Ciebie przed halą przylotów lub na miejscu odbioru."
          },
          fourth: {
            title: "Wygodne płatności",
            description: "Płacisz jak chcesz. Możesz dokonać opłaty dopiero po przyjeździe kierowcy lub od razu za pośrednictwem aplikacji z dodaną wcześniej kartą płatniczą."
          }
        }
      },
      hortenTorp: {
        title: "Sprawny Bus Lotniskowy Horten – Torp (TRF)",
        intro: "Odbieramy Cię bezpośrednio przy terminalu promowym w Horten i zawozimy prosto pod drzwi lotniska Sandefjord Torp. Bez przesiadek w pociągach i bez stresu z parkowaniem.",
        heroButton: "Zarezerwuj Transfer Teraz",
        feature: {
          title: "Przypływasz promem Bastøferga z Moss / Østfold?",
          description: "Zapomnij o stresie związanym ze skomplikowanym rozkładem jazdy transportu publicznego czy dźwiganiem ciężkich bagaży na duże odległości. <strong>Flyo odbierze Cię bezpośrednio przy terminalu promowym w Horten.</strong> Nasz kierowca czeka tuż po Twoim zejściu z promu Bastøferga. To gwarancja w pełni płynnej podróży z Moss, przez Horten, prosto pod terminal odlotów na lotnisku Torp."
        },
        comparison: {
          title: "Dlaczego warto wybrać Flyo zamiast auta lub pociągu?",
          subtitle: "Zobacz, jak Flyo oszczędza Twój czas, pieniądze i energię w porównaniu do tradycyjnych form podróży na trasie Horten – Torp:",
          columns: {
            method: "Środek transportu",
            time: "Czas i komfort",
            cost: "Koszty i stres"
          },
          flyo: {
            name: "Transfer Flyo",
            time: "Bezpośrednio pod terminal (ok. 35 min). Godzina odjazdu dopasowana do Twojego lotu.",
            cost: "Stała niska cena. Brak opłat drogowych (bompenger) i drogiego parkingu lotniskowego."
          },
          car: {
            name: "Własny samochód",
            time: "Elastycznie, ale musisz prowadzić sam i brać poprawkę na korki w godzinach szczytu.",
            cost: "Kosztownie. Opłaty drogowe + parking na Torp to łatwo ponad 800 kr za tydzień postoju."
          },
          train: {
            name: "Pociąg / Komunikacja",
            time: "Uciążliwe. Wymaga dojazdu do stacji Skoppum, pociągu do stacji Torp i kolejnego busa pod terminal.",
            cost: "Przystępnie dla jednej osoby, ale bardzo czasochłonne i stresujące przy podróży z dużym bagażem."
          }
        },
        steps: {
          title: "Jak działa trasa Horten – Torp z Flyo",
          subtitle: "Od rezerwacji do przyjazdu: Prosty, przewidywalny i wygodny transport.",
          first: {
            title: "Rezerwacja w 2 minuty",
            description: "Wybierz datę oraz godzinę odlotu lub przylotu na Torp. Jako miejsce odbioru wskaż Terminal Promowy w Horten."
          },
          second: {
            title: "Spotkanie na miejscu",
            description: "Korzystamy ze stałych, łatwo dostępnych punktów przesiadkowych w Horten. Nasz kierowca czeka w wyznaczonym miejscu i pomoże Ci z bagażem."
          },
          third: {
            title: "Relaks w podróży",
            description: "Ciesz się jazdą w jednym z naszych komfortowych, nowoczesnych samochodów. Jedziemy prosto trasą E18 bez zbędnych objazdów."
          },
          fourth: {
            title: "Pod samym wejściem",
            description: "Wysiadacie tuż przed halą odlotów lotniska Sandefjord Torp. Jesteście gotowi do odprawy w kilka sekund."
          }
        },
        faq: {
          title: "Najczęściej zadawane pytania (FAQ)",
          subtitle: "Wszystko, co musisz wiedzieć o swoim transferze między Horten a lotniskiem Sandefjord Torp.",
          first: {
            question: "Gdzie dokładnie przy terminalu promowym w Horten następuje odbiór?",
            answer: "Nasze samochody zatrzymują się w specjalnej strefie krótkiego postoju (hente-/bringeplass) tuż obok wyjścia dla pasażerów pieszych z terminalu Bastøferga w Horten. Przed kursem otrzymasz wiadomość SMS z numerem telefonu kierowcy oraz numerem rejestracyjnym pojazdu."
          },
          second: {
            question: "Co się stanie, jeśli mój prom lub lot będzie opóźniony?",
            answer: "Ponieważ działamy na bazie rezerwacji, stale monitorujemy statusy przylotów na Torp oraz sytuację na drogach. W przypadku niewielkich opóźnień promu staramy się elastycznie dopasować czas odbioru, aby nikt nie został na lodzie."
          },
          third: {
            question: "Czy mogę zamówić odbiór spod prywatnego adresu domowego w Horten?",
            answer: "Nie, obsługujemy wyłącznie stałe, centralne punkty przesiadkowe w Horten. Pozwala nam to zapewnić maksymalną punktualność, sprawność i przewidywalność rozkładu dla wszystkich pasażerów."
          }
        },
        bottomCta: {
          title: "Gotowy na bezstresową podróż na lotnisko Torp?",
          description: "Zarezerwuj swoje miejsce już dziś i zapewnij sobie spokojny oraz komfortowy początek podróży.",
          button: "Sprawdź cenę i zamów teraz"
        }
      },
      complaint: {
        title: "Reklamacja dotycząca transferu lub przejazdu taxi",
        introFirst: "Flyo AS chce, aby każdy klient czuł się bezpiecznie i był zadowolony z przejazdu. Jeśli podczas Twojej podróży coś poszło nie tak – niezależnie od tego, czy chodzi o cenę, opóźnienie, wybraną trasę, zachowanie kierowcy czy inne okoliczności – prosimy o skorzystanie z poniższego formularza reklamacyjnego.",
        introSecond: "Wszystkie reklamacje rozpatrujemy na bieżąco. Otrzymasz pisemne potwierdzenie zarejestrowania zgłoszenia, a ostateczną odpowiedź staramy się przekazać w ciągu <strong>10 dni roboczych</strong>.",
        form: {
          contact: {
            title: "1. Dane kontaktowe",
            name: {
              label: "Imię i nazwisko",
              placeholder: "Jan Kowalski"
            },
            email: {
              label: "Adres e-mail",
              placeholder: "jan@przyklad.pl"
            },
            phone: {
              label: "Numer telefonu",
              placeholder: "+47 000 00 000"
            }
          },
          trip: {
            title: "2. Informacje o przejeździe",
            datetime: {
              label: "Data i godzina przejazdu"
            },
            license: {
              label: "Numer licencji lub numer rejestracyjny pojazdu",
              placeholder: "Np. Licencja 1234 / AB 12345"
            },
            pickup: {
              label: "Adres odbioru / Skąd",
              placeholder: "Adres lub lotnisko"
            },
            dropoff: {
              label: "Adres docelowy / Dokąd",
              placeholder: "Adres"
            }
          },
          details: {
            title: "3. Czego dotyczy reklamacja?",
            category: {
              label: "Kategoria reklamacji",
              empty: "-- Wybierz kategorię --",
              price: "Cena / Taryfa / Naliczenie",
              delay: "Opóźnienie / Niepodstawienie pojazdu",
              driver: "Zachowanie kierowcy / Obsługa",
              route: "Wybór trasy przejazdu",
              vehicle: "Stan pojazdu / Czystość",
              other: "Inne"
            },
            description: {
              label: "Opisz zdarzenie tak szczegółowo, jak to możliwe",
              placeholder: "Opisz, co się wydarzyło, ewentualnie uzgodnioną cenę, zastosowaną taryfę itp."
            },
            attachments: {
              label: "Dokumentacja / Paragon",
              description: "Ewentualne załączniki (paragon, wyciąg z konta, potwierdzenie ceny) wyślij bezpośrednio e-mailem na adres",
              descriptionEnd: "wraz ze swoim numerem referencyjnym."
            }
          },
          submit: "Wyślij reklamację",
          sending: "Wysyłanie..."
        },
        success: {
          title: "Dziękujemy – Twoja reklamacja została zarejestrowana",
          registered: "Otrzymaliśmy Twoje zgłoszenie i zarejestrowaliśmy sprawę.",
          referenceLabel: "Twój numer referencyjny zgłoszenia to:",
          keepIt: "Zachowaj ten numer. Otrzymasz pisemne potwierdzenie e-mailem, a ostateczną odpowiedź staramy się przekazać w ciągu 10 dni roboczych.",
          attachments: "Chcesz przesłać dokumentację (paragon, wyciąg z konta, potwierdzenie ceny)? Wyślij ją e-mailem na adres",
          attachmentsEnd: "podając powyższy numer referencyjny."
        },
        appeal: {
          title: "Niezależny organ odwoławczy (Dalsza droga reklamacyjna)",
          description: "Jeżeli złożyłeś reklamację w Flyo AS i nie zgadzasz się z naszą decyzją lub nie otrzymasz odpowiedzi w rozsądnym terminie, zgodnie z norweskimi przepisami o transporcie zawodowym masz prawo skierować sprawę do <strong>Norweskiego Urzędu Ochrony Konsumentów (Forbrukertilsynet)</strong> w celu niezależnej mediacji. Więcej informacji znajdziesz na"
        },
        legal: {
          licenceHolder: "Posiadacz licencji centralnej",
          email: "E-mail w sprawach reklamacji:",
          compliance: "Spełnia wymogi norweskiej ustawy o transporcie zawodowym § 9."
        }
      },
      faq: {
        title: "FAQ",
        description: "Lista najczęściej zadawanych pytań",
        generalTitle: "Ogólne",
        paymentTitle: "Płatność",
        accountTitle: "Moje konto",
        generalQuestions:
          [
            {
              title: 'Jak zarezerwować transfer lotniskowy?',
              paragraph: 'Możesz zarezerwować transfer na lotnisko, korzystając z naszego formularza rezerwacji lub kontaktując się z nami pod adresem support@flyo.no'
            },
            {
              title: 'Gdzie mogę Was znaleźć na lotnisku?',
              paragraph: 'Znalezienie kierowcy na lotnisku jest łatwe. Kierowca będzie czekał na Ciebie przed halą przylotów. <br /><br />Szukaj kierowcę z naszym logo Flyo!'
            },
            {
              title: 'Czy oferujecie transfer lotniskowy na lotnisko Gardermoen?',
              paragraph: 'Nie oferujemy transferów autobusowych na lotnisko Oslo Gardermoen.'
            },
            {
              title: 'Rozkład nie odpowiada mojemu lotowi.',
              paragraph: 'Jeśli rozkład nie pasuje do Twojego lotu oznacza to, że nie jeździmy na ten konkretny lot.'
            },
            {
              title: 'Gdzie znajdę rozkład jazdy busów?',
              paragraph: 'Godziny odjazdów naszego busu można znaleźć podczas rezerwacji przejazdu.'
            },
            {
              title: 'Jakie loty obsługujecie?',
              paragraph: 'Możesz znależć listę wszystkich lotów, które obsługujemy w naszej aplikacji. Jeśli nie znalazłeś swojego lotu, możesz dokonać rezerwacji na inny, o podobnej godzinie.'
            },
            {
              title: 'Czy mogę przesunąć rezerwację na inny dzień?',
              paragraph: 'Jeśli chcesz zmienić datę transportu, możesz anulować istniejącą rezerwację i utworzyć nową. Jeśli zapłaciłeś kartą z gòry, otrzymasz automatycznie zwrot pieniędzy jeśli anulowałes minimum 8 godzin przed lotem.'
            },
            {
              title: 'Czy dysponujecie fotelikami dla dzieci?',
              paragraph: 'Tak. Dokonując rezerwacji za pośrednictwem naszej strony, możesz wybrać rodzaj fotelika, którego potrzebujesz. Jeśli dokonujesz rezerwacji przez e-mail, znajdziemy dla Ciebie odpowiedni fotelik.'
            }
          ]
        ,
        paymentQuestions:
          [
            {
              title: 'Czy mogę płacić kartą?',
              paragraph: 'Tak. Zarówno w aplikacji, jak i bezpośrednio u kierowcy w busie możesz płacić kartami Visa oraz Mastercard.'
            },
            {
              title: 'Czy mogą płacić w gotówce?',
              paragraph: 'Tak. Przyjmujemy płatność w gotówce w koronach norweskich (NOK).'
            },
            {
              title: 'Czy pieniądze zostaną mi zwrócone?',
              paragraph: 'Jeśli anulujesz podróż do 8 godz. przed lotem, zwrócimy Ci poniesione koszty. Pieniądze wrócą na Twoje konto do 10 dni roboczych.'
            },
          ],
        accountQuestions:
          [
            {
              title: 'Jak utworzyć konto?',
              paragraph: 'Aby utworzyć konto, wejdź w zakładkę "rejestracja" na naszej stronie internetowej. Będziesz jedynie musiał zweryfikowac swój numer telefonu.'
            },
            {
              title: 'Czy mogę wprowadzać zmiany w swojej rezerwacji?',
              paragraph: 'Możesz dowolnie edytować swoją rezerwację do godziny 18.00 na dzień przed wylotem. Możesz anulować istniejącą rezerwację, a następnie utworzyć nową.'
            },
            {
              title: 'Jak anulować rezerwację?',
              paragraph: 'Możesz anulować rezerwację, logując się na swoje konto, przechodząc do "Przejazdy" i klikając przycisk usun rezerwacje. <br /><br />Jeśli nie masz konta, możesz anulować przejazd, wysyłając do nas e-mail support@flyo.no, a ktoś z naszego zespołu anuluje rezerwację za Ciebie.'
            },
            {
              title: 'Zapomniałem hasła.',
              paragraph: 'Możesz stworzyć nowe hasło używając opcji "Zapomniałem hasła". Smsem otrzymasz od nas kod, po wpisaniu którego będziesz mógł utworzyć nowe hasło.'
            },
            {
              title: 'Mam nowy nr telefonu.',
              paragraph: 'Numer telefonu możesz zmienić po zalogowaniu się w aplikacji w zakładce "Moje konto.'
            },
          ]
      },
      contact: {
        title: "Kontakt",
        description: "Zwróć się do nas, a chętnie odpowiemy na wszelkie Twoje pytania.",
        desc: {
          title: "W kontakcie!",
          content: "Skontaktuj się z nami",
          paragraphs: {
            first: {
              title: "Nasze biuro pracuje od poniedziałku do piątku",
              desc: "od 10:00 do 16:00"
            },
            second: {
              title: "Co możemy dla Ciebie zrobić?",
              //              desc: "We’re here to help"
            },
            third: {
              title: "Dokonaj rezerwacji",
              desc: "Możesz zarezerwować transfer z lotniska Oslo Torp za pomocą naszej strony lub kontaktując się z nami przez e-mail."
            },
            fourth: {
              title: "Wsparcie klienta",
              desc: "Czy masz jakiekolwiek pytania? Skonaktuj się z nami, z przyjemnością rozwiejmy wszelkie wątpliwości!"
            }
          }
        },
        form: {
          title: "Skontaktuj się z nami",
          inputs: {
            name: {
              label: "Imię i nazwisko / firma",
              placeholder: "Twoje imię"
            },
            email: {
              label: "email",
              placeholder: "Twój email"
            },
            message: {
              label: "Twoja wiadomość",
              placeholder: "Co chcesz nam powiedzieć?"
            },
            sendButton: "Wyślij",
            sendingButton: 'Wysyła...'
          }
        }
      },
      pricing: {
        title: "Cennik przejazdów",
        desc: "Skorzystaj z najlepszych cen przejazdu do i z lotniska Oslo Torp",
        adults: "dorośli",
        kids: "dzieci*",
        teenagers: 'nastolatkowie 13-17',
        students: 'studenci',
        seniors: 'seniorzy (67+)',
        info: "*Możesz skorzystać z tańszych biletów dla dzieci do 12 roku życia.",
        doorToDoor: {
          title: "Transfer pod adres Oslo Sandefjord Torp",
          column: "pod adres",
        },
        busStop: {
          title: "Transfer z przystanku Oslo Sandefjord Torp",
          column: "przystanek",
        }
      },
      termsAndConditions: {
        title: "Regulamin",
        desc: "Zasady jazdy z Flyo",
        general: {
          title: "Główne zasady",
          list: [
            { content: "Operatorem, którym jest transfer z lotniska, jest Flyo AS z siedzibą w Bekkenstenveien 53B, Oslo, zwanym dalej „przewoźnikiem”." },
            { content: "Niniejsze warunki określają zasady sprzedaży biletów, transportu pasażerów i bagażu przewożonych przez Flyo AS." },
            { content: "Dokumentem upoważniającym do transferu jest „potwierdzenie SMS”, „potwierdzenie e-mailem” lub „pokwitowanie z kasy fiskalnej”, zwane dalej „biletem”." },
            { content: "Dokonanie rezerwacji w Flyo AS oznacza akceptację „Warunków”" }
          ]
        },
        booking: {
          title: "Warunki rezerwacji",
          list: [
            { content: "Rezerwacje na transfer lotniskowy można dokonać za pomocą aplikacji rezerwacyjnej lub dzwoniąc na linię obsługi klienta. Rezerwacja jest potwierdzana po otrzymaniu e-maila z potwierdzeniem lub SMSem." },
            { content: "Nie ma potrzeby drukowania wiadomości e-mail z potwierdzeniem. Kierowca zostanie poinformowany o wszystkich pasażerach i będzie potrzebował imię i / lub numeru telefonu." },
            { content: "Dane klientów nie są udostępniane ani sprzedawane osobom trzecim, a wszystkie dane klientów są przechowywane zgodnie z prawem norweskim." },
            { content: "Flyo AS odpowiada za wykonanie i jakość sprzedawanej usługi." },
            {
              content: "Flyo AS odpowiada za:",
              list: [
                { content: "transakcje kartą kredytową dokonywane za pośrednictwem tej strony internetowej." },
                { content: "informowanie, kiedy kierowca będzie w uzgodnionym miejscu odbioru, dzień przed odlotem." },
                { content: "informowanie o wszelkich istotnych zmianach w rezerwacji." },
              ]
            },
            { content: "Rezerwacja staje się wiążąca, gdy zostanie potwierdzona telefonicznie lub pisemnie przez Flyo AS. Rezerwacje online stają się wiążące po otrzymaniu wiadomości e-mail z potwierdzeniem." },
            { content: "Aby anulować lub edytować rezerwację, skontaktuj się z Flyo za pośrednictwem poczty e-mail: <a href='mailto:support@flyo.no'>support@flyo.no</a>. Można to również zrobić ręcznie za pośrednictwem naszej strony." },
            { content: "Anulowanie rezerwacji może nastąpić do 8 godzin przed planowanym lotem z pełnym zwrotem kosztów. Zwrot nie zostanie dokonany, jeśli odwołanie nastąpi mniej niż 8 godzin przed planowanym lotem." },
            { content: "Zmiana rezerwacji na inną datę jest bezpłatna, jeśli została dokonana więcej niż 8 godzin przed planowanym odlotem." },
            { content: "Edytowanie pasażerów, miejsca odbioru i fotelików dziecięcych jest możliwe do godziny 18.00 jeden dzień przed lotem i jest bezpłatne." },
            { content: "Ceny są w koronach norweskich (NOK). Wszystkie ceny zawierają podatek VAT." },
          ]
        },
        carrier: {
          title: "Przewoźnik",
          list: [
            { content: "Przewoźnik nie ponosi odpowiedzialności za opóźnienia i ich dalsze konsekwencje spowodowane czynnikami administracyjnymi (np. Kontrole policyjne) lub innymi czynnikami niezależnymi od Przewoźnika (np. Problemy techniczne, warunki pogodowe, korki)." },
            { content: "Przewoźnik będzie dążył do przewozu pasażera i bagażu w rozsądnym czasie zgodnie z planem podróży, ale z przyczyn od niego niezależnych nie może tego zagwarantować." },
            { content: "Przewoźnik zastrzega sobie prawo do korzystania z usług połączeń w trakcie podróży ze względów logistycznych lub dla bezpieczeństwa pasażerów." },
            { content: "Pasażerowie, którzy nie są w stanie podróżować z winy Przewoźnika, mają prawo do kwoty zwrotu odpowiadającej niewykorzystanemu biletowi." },
            { content: "Rezerwacji autobusu dokonuje się poprzez złożenie zamówienia przez telefon lub za pośrednictwem formularza rezerwacji na <a href='https://flyo.no'>www.flyo.no</a>. Rezerwacje są potwierdzane w momencie otrzymania e-maila z potwierdzeniem." },
            {
              content: "Przewoźnik ma prawo nie dopuścić pasażerów w autobusie lub odmówić dalszego przewozu bez zwrotu kosztów poniesionych przez Pasażera, gdy pasażer:",
              list: [
                { content: "nie jest zgodny z zasadami tych przepisów," },
                { content: "jest pod wpływem alkoholu lub narkotyków" },
                {
                  content: "jest w stanie lub zachowuje się w sposób, który może niekorzystnie wpłynąć na bezpieczeństwo lub komfort innych pasażerów. <br>Skutki prawne tych sytuacji ponosi Pasażer."
                }
              ]
            },
            { content: "Nie wolno spożywać napojów alkoholowych, narkotyków ani papierosow." },
            { content: "Dozwolone jest przewożenie niektórych zwierząt domowych po uprzednim poinformowaniu Przewoźnika. Transportowane zwierzę musi być odpowiednio zabezpieczone, znajdować się w klatce i być umieszczone na siedzeniu obok pasażera. Transport zwierząt musi odbywać się bez przeszkadzania innym pasażerom podczas podróży." },
            { content: "Koszt transportu, podatków, opłat i opłat za usługi Flyo AS nie podlega zwrotowi w przypadku, gdy pasażer nie pojawi się w uzgodnionym miejscu spotkania." },
          ]
        },
        passengers: {
          title: "Pasażerowie",
          list: [
            { content: "Pasażerowie powinni przybyć do wyznaczonego miejsca o wyznaczonej godzinie. Przewoźnik nie ma obowiązku czekać na pasażerów niespełniających tego warunku." },
            { content: "Pasażerowie są zobowiązani do przestrzegania przepisów policyjnych podczas podróży." },
            { content: "Pasażerowie są odpowiedzialni za wszelkie szkody wyrządzone Przewoźnikowi (w szczególności za szkody w autobusie) i innym pasażerom na ogólnych zasadach określonych w Kodeksie cywilnym." },
            { content: "Pasażerowie muszą korzystać z pasów bezpieczeństwa podczas podróży." },
            { content: "Dzieci poniżej 12 roku życia, które nie przewyższają 150 cm wysokości, przewożone w autobusie muszą korzystać z fotelików lub innego sprzętu do przewożenia dzieci, odpowiadającego wadze i wzrostowi dziecka. Dziecko powinno pozostać przez całą podróż w zabezpieczonym fotelu ochronnym. Pasażer musi powiadomić Przewoźnika, które foteliki ochronne należy zabrać przy tworzeniu rezerwacji." },
            { content: "Przewoźnik nie ponosi odpowiedzialności za nieletnich podróżujących bez opiekuna." },
            { content: "Przewoźnik nie ponosi odpowiedzialności za przedmioty pozostawione w autobusie." }
          ]
        }
      },
      privacyPolicy: {
        title: "Polityka prywatności",
        introduction: {
          title: "Wstęp",
          list: [
            { content: "<strong>Flyo AS</strong> („Przewoźnik”) dokłada wszelkich starań, aby nam zaufać i przetwarzać dane osobowe. Dlatego w niniejszym oświadczeniu o ochronie prywatności wyjaśniamy, dlaczego zbieramy informacje o Tobie, w jaki sposób korzystamy z tych informacji i jak uwzględniamy Twoją prywatność." },
            { content: 'Dane osobowe to informacje i oceny, które można powiązać z dającą się zidentyfikować osobą. Mogą to być na przykład nazwiska i dane kontaktowe, historia transakcji lub informacje o zainteresowaniach.' },
            { content: "Wykorzystanie danych osobowych musi być zgodne z ustawą o danych osobowych. My, jako kontroler, zapewniamy, że będziemy wykorzystywać Twoje dane osobowe zgodnie z prawem." }
          ]
        },
        whatPersonalInformation: {
          title: "Jakie dane osobowe mamy o Tobie?",
          list: [
            { content: "W zależności od tego, jakie informacje nam przekazujesz, w jaki sposób korzystasz z naszych usług i jakie uprawnienia nam przekazujesz, mamy następujące informacje o Tobie:" },
            { content: '<strong>Informacje o Tobie:</strong> Informacje podawane podczas tworzenia konta użytkownika lub zamówienia biletów, takie jak imię i nazwisko, adres, numer telefonu i adres e-mail.' },
            { content: "<strong>Informacje o zakupie:</strong> informacje, które otrzymujemy, gdy kupujesz u nas bilety, takie jak zakup, numer karty i metoda płatności (np. Visa). Jeśli masz konto użytkownika u nas, otrzymasz przegląd swoich poprzednich przejazdów na koncie użytkownika." },
            { content: "<strong>Komunikacja:</strong> Informacje, które przekazujesz nam, gdy kontaktujesz się z naszym centrum obsługi klienta, takie jak wiadomości e-mail wysyłane między nami." },
            { content: "<strong>Informacje o użytkowaniu strony internetowej:</strong> Informacje, które otrzymujemy podczas korzystania z naszej strony internetowej i aplikacji, takie jak rodzaj posiadanego urządzenia (np. Telefon komórkowy lub komputer), adres IP, odwiedzane strony i funkcje, których tam używasz." },
            { content: "<strong>Informacje o profilowaniu:</strong> informacje i założenia, które automatycznie tworzymy w oparciu o inne informacje (o których mowa powyżej) o Tobie, takie jak Twoje preferencje i zainteresowania oraz do jakich grup demograficznych należysz, chyba że temu zaprzeczasz." },
          ]
        },
        whatWeUsePersonalInformationFor: {
          title: "Do czego wykorzystujemy dane osobowe",
          list: [
            { content: "Wykorzystujemy Twoje dane osobowe do następujących celów:" },
            { content: '<strong>Witryna i aplikacja:</strong> Używamy tych informacji, aby dostosować naszą stronę internetową i aplikację do używanego sprzętu technicznego.' },
            { content: "<strong>Wykonaj rezerwację biletów:</strong> Używamy tych informacji do ukończenia zakupu biletu, w tym: aby wysłać Ci bilety, otrzymać płatność i zapisać historię zakupów." },
            { content: "<strong>Tworzenie konta użytkownika:</strong> Używamy informacji, jeśli tworzysz konto, musisz podać nazwę użytkownika i hasło, aby przechowywać informacje kontaktowe i informacje o płatnościach, a także aby wyświetlić historię zakupów." },
            { content: "<strong>Obsługa klienta:</strong> Przechowujemy informacje, które przekazujesz i otrzymujesz, jeśli skontaktujesz się z nami w celu świadczenia usług i zarządzania relacjami z klientami." },
            { content: "<strong>Statystyki:</strong> Tworzymy statystyki i mapujemy trendy rynkowe w celu ulepszenia i dalszego rozwoju naszych produktów i usług. W miarę możliwości robimy to za pomocą anonimowych informacji." },
            { content: "<strong>Marketing:</strong> Używamy Twoich danych kontaktowych (np. Numeru telefonu i adresu e-mail) do wysyłania Ci rekomendacji i informacji o naszych usługach. Możemy wykorzystywać informacje profilowania, aby zalecenia i informacje były dla Ciebie najbardziej istotne, chyba że temu zaprzeczasz. Jeśli chcesz, prześlemy Ci także zalecenia i informacje o występach naszych partnerów." },
            { content: "Podstawą prawną dla celów <strong>1</strong>, <strong>4</strong> i <strong>5</strong> jest nasz uzasadniony interes w dostarczaniu, rozwijaniu i marketingu naszych usług." },
            { content: "Podstawą prawną dla celów <strong>2</strong>, <strong>3</strong> i <strong>4</strong> jest wypełnienie naszej umowy z tobą." },
            { content: "Podstawą prawną celu <strong>5</strong> może być również twoja zgoda, jeśli nam to dałeś. Może być konieczne wysłanie Ci marketingu, jeśli nie masz już konta użytkownika, lub jeśli wysyłamy Ci marketing dotyczący wyników naszych partnerów." },
          ]
        },
        whoWeSharePersonalInformationWith: {
          title: "Komu udostępniamy dane osobowe",
          list: [
            { content: "Udostępniamy dane osobowe firmom, które świadczą nam usługi techniczne i administracyjne, takie jak dostawcy IT. Mamy z nimi umowy, aby zapewnić prywatność." },
            { content: "Możemy ujawniać informacje w indywidualnych przypadkach, na przykład organom publicznym, w przypadku podejrzenia popełnienia przestępstwa." },
            { content: "Jeśli wyrazisz na to zgodę, możemy udostępnić Twoje dane osobowe naszym partnerom, zgodnie z Twoją zgodą. Używamy dostawców IT na terenie Polski." },
            { content: "Możemy także udostępniać anonimowe informacje partnerom, między innymi. analiza rynku i rozwój usług." },
          ]
        },
        howLongWeStorePersonalInformation: {
          title: "Jak długo przechowujemy dane osobowe",
          list: [
            { content: "Przechowujemy informacje o Tobie tylko tak długo, jak jest to konieczne do osiągnięcia celu, dla którego zostały uzyskane, lub jeśli jesteśmy zobowiązani do przechowywania informacji. Informacje zostaną usunięte lub zanonimizowane, gdy nie będą już potrzebne do tego celu. Poniżej znajduje się przegląd tego, jak długo przechowujemy Twoje informacje:" },
            { content: "<strong>Informacje o Tobie:</strong> Jeśli masz konto użytkownika u nas, możesz skontaktować się z nami, a my usuniemy informacje o Tobie." },
            { content: "<strong>Informacje o zakupie:</strong> jeśli masz konto użytkownika u nas, będziemy przechowywać historię przejazdów. Przechowujemy transakcje i informacje o płatnościach przez 5 lat zgodnie z ustawą o rachunkowości." },
            { content: "<strong>Informacje o korzystaniu z witryny:</strong> przechowujemy informacje o korzystaniu z naszej strony internetowej przez okres do 6 miesięcy." },
            { content: "<strong>Informacje o partnerach:</strong> Przechowujemy wszelkie informacje dotyczące partnerów, o ile masz aktywne konto użytkownika u nas lub tak długo, jak wyrażasz na to zgodę. Usuniemy informacje, jeśli anulujesz swoje konto użytkownika." },
            { content: "<strong>Komunikacja:</strong> Przechowujemy komunikację z naszymi klientami przez trzy lata, chyba że musimy przechowywać je dłużej, np. w związku ze skargami lub roszczeniami." },
            { content: "<strong>Informacje o profilowaniu:</strong> jeśli masz konto użytkownika u nas, usuniemy te informacje po zakończeniu konta użytkownika lub konta użytkownika. Usuniemy informacje wcześniej, jeśli sprzeciwiasz się profilowaniu." },
          ]
        },
        yourRights: {
          title: "Twoje prawa",
          list: [
            { content: "Masz prawo poprosić nas o:" },
            {
              list: [
                { content: "Dodatkowe informacje o tym, jak przetwarzamy Twoje dane osobowe." },
                { content: "Kopię danych osobowych o Tobie." },
                { content: "Zaktualizowanie swoich danych osobowych." },
                { content: "Usuń informacje, które nie mają już podstaw do przechowywania." },
                { content: "Ogranicz lub zatrzymaj przetwarzanie swoich informacji." },
                { content: "Zatrzymanie automatycznym indywidualnym decyzjom, w tym profilowaniu." },
                { content: "Informacje, które nam przekazałeś w ustrukturyzowanym, powszechnie używanym i czytelnym dla komputera formacie lub, jeśli jest to technicznie możliwe, poproś nas o przeniesienie ich do innej firmy." },
                { content: "Wycofanie wszelkie udzielone nam zgody." },
              ]
            },
            { content: "Należy pamiętać, że istnieją ograniczenia tych praw. Skontaktuj się z nami, aby uzyskać więcej informacji na ten temat." },
            { content: "Jeśli uważasz, że przetwarzamy dane osobowe z naruszeniem Ustawy o danych osobowych, masz prawo odwołania się do Inspektoratu Danych. Zanim to zrobisz, chcielibyśmy, abyś skontaktował się z nami, abyśmy mogli odpowiedzieć na Twoje pytania lub rozwiązać wszelkie nieporozumienia." },
          ]
        },
        cookies: {
          title: "Plików cookie",
          list: [
            { content: "Używamy plików cookie na naszej stronie, aby zapewnić funkcjonalność strony, przeanalizować ruch w sieci i zobaczyć, które witryny w naszej witrynie odwiedziłeś." },
          ]
        },
        changesToThePrivacyStatement: {
          title: "Zmiany w oświadczeniu o ochronie prywatności",
          list: [
            { content: "Możemy okresowo aktualizować oświadczenie o ochronie prywatności. Zostaniesz powiadomiony o istotnych zmianach. Zawsze znajdziesz najnowszą wersję naszego oświadczenia o ochronie prywatności na stronie / aplikacji." },
          ]
        },
        contactInformation: {
          title: "Informacje kontaktowe",
          list: [
            { content: "Jeśli chcesz się z nami skontaktować, możesz użyć następujących informacji kontaktowych:" },
          ],
          address: [
            { content: 'Adres e-mail: <a href="mailto:support@flyo.no" itemProp="email">support@flyo.no</a>' },
            { content: 'Adres: <span itemProp="streetAddress">Bekkenstenveien 53B</span>,<span itemProp="postalCode">0976</span> <span itemProp="addressLocality">Oslo</span>' },
          ]
        },
      },
    },
    notifications: {
      default: {
        success: "Sukces",
      },
      contact: {
        error: 'Błąd',
        cannotBeSent: 'Twój e-mail nie może zostać wysłany. Spróbuj ponownie.',
        success: 'Wiadomość wysłana!',
        successMessage: 'Odpowiemy wkrótce.'
      },
      complaint: {
        error: 'Błąd',
        cannotBeSent: 'Reklamacja nie mogła zostać wysłana. Spróbuj ponownie później.',
        requiredFields: 'Należy uzupełnić wymagane pola.',
        invalidForm: 'Nie udało się przetworzyć formularza. Sprawdź dane i spróbuj ponownie.',
        invalidData: 'Część danych nie została zaakceptowana. Sprawdź pola zaznaczone poniżej.',
        sendFailed: 'Reklamacji nie udało się wysłać z powodu błędu technicznego. Spróbuj ponownie za chwilę lub wyślij zgłoszenie e-mailem na support@flyo.no.',
        success: 'Reklamacja wysłana!',
        successMessage: 'Otrzymasz pisemne potwierdzenie e-mailem, a ostateczną odpowiedź w ciągu 10 dni roboczych.'
      },
      reviews: {
        error: 'Błąd',
        noComment: 'Wprowadź komentarz',
        success: 'Twoja opinia została wysłana. Dziękujemy!'
      },
      settings: {
        success: "Zapisano",
        error: "Ups! Nie można zapisać. Odśwież stronę i spróbuj ponownie."
      },
      invoices: {
        successMessage: "Dane zostały zapisane.",
        errorTitle: "Błąd"
      },
      cards: {
        success: "Dodano kartę.",
        error: "Błąd"
      },
      cardItems: {
        success: "Karta została usunięta.",
        error: "Błąd",
        errorMessage: "Wystąpił błąd podczas usuwania karty."
      },
      addressItem: {
        success: "Adres został usunięty.",
        error: "Błąd",
        errorMessage: "Wystąpił błąd podczas usuwania adresu."
      },
      addressComponent: {
        noResults: "No results",
        warning: {
          title: "Uwaga!",
          addressInvalid: "Adres nie jest poprawny.",
          addressInDatabase: "Adres jest już zapisany."
        }
      },
      facebook: {
        error: "Błąd"
      },
      google: {
        error: "Błąd"
      },
      loginPage: {
        error: "Błąd"
      },
      loginForm: {
        success: "Zostałeś zalogowany.",
        error: "Błąd"
      },
      bookingStep4: {
        error: "Błąd"
      },
      phoneSmsVerification: {
        success: "Numer telefonu został zmieniony.",
        error: "Błąd",
        errorMessage: "Podaj cały kod."
      },
      phoneNumberVerification: {
        success: "Konto zostało utworzone i zostałeś zalogowany.",
        error: "Błąd",
        invalidMessage: "Podaj cały kod."
      },
      profileResetPassword: {
        success: "Hasło zostało zmienione.",
        error: "Błąd"
      },
      mapPlaces: {
        success: {
          addressInDatabase: "Adres jest już zapisany.",
        },
        warning:
        {
          title: "Uwaga!",
          addressSaved: "Adres został zapisany."
        },
        error: "Błąd",
        errorMessage: "Wystąpił błąd podczas zapisywania adresu",
      },
      reservationEdit: {
        error: "Błąd",
        errorSubmit: "Błąd!",
        warning: {
          title: "Uwaga!",
          message: "Nie zmieniono parametrów rezerwacji."
        }
      },
      suplementSummary: {
        success: "Zmiany w rezerwacji zostały zapisane.",
        error: "Błąd"
      },
      notificationButtons: {
        cancelSuccess: "Rezerwacja została anulowana.",
        error: "Błąd",
      }
    },
    supplementSummary: {
      paySupl: "Zapłać"
    },
    reservationEdit: {
      address: "Adres",
      editAddress: "Edytuj adres",
      passengers: "Pasażerowie",
      adults: "dorośli",
      kids: "dzieci",
      editPassengers: "Edytuj pasażerów",
      oldPrice: "Stara cena",
      changePrice: "Zmiana w cenie",
      newPrice: "Nowa cena",
      payWithCard: "Wybrałeś płatność kartą",
      payDriver: "Wybrałeś płatność u kierowcy. Nie musisz płacić teraz.",
      changeDetails: "Zmień szczegóły rezerwacji",
      changeNothing: "Nie chcę niczego zmieniać",
      reservationEditPassengers: {
        title: "Pasażerowie",
        desc: "Zmiana planów? Zaktualizuj ilość pasażerów",
        adults: "dorośli",
        kids: "dzieci",
        kidsSafetyTitle: "Foteliki bezpieczeństwa",
        tripMessage: "Podróżujesz z dziećmi.",
        carSeatsMessage: "Jakich fotelików potrzebujesz?",
      }
    },
    form: {
      inputPhoneNumber: "numer telefonu",
      changePhoneNumber: "Zmień numer telefonu",
      changePassword: "Zmień hasło",
      changePhoneAndPassword: "Edytuj numer telefonu i hasło",
      changePhoneDescriptionFirst: "Nowy numer teletonu musi być jeszcze raz zweryfikowany.",
      changePhoneDescriptionSecond: "Wyślemy Ci kod weryfikacyjny smsem.",
      changePhoneSuccessMessage: "Pomyślnie zmieniono numer telefonu."
    },
    errors: {
      passengerCount: "Uzupełnij poprawnie ilość pasażerów.",
      childrenSeats: 'Wybierz fotelik dla dzieci.',
      card: {
        cardNumber: 'Niepoprawny numer karty.',
        cardCvc: 'Niepoprawny CVC.',
        date: 'Niepoprawna data.',
        datePast: 'Data nie może być przeszła.'
      },
      contact: {
        email: 'E-mail jest nie prawidłowy',
        name: 'Imię jest nieprawidłowe',
        message: 'Wiadomość jest nieprawidłowa',
      },
      complaint: {
        name: 'Podaj imię i nazwisko',
        email: 'Podaj adres e-mail',
        emailInvalid: 'Adres e-mail jest nieprawidłowy',
        phone: 'Podaj numer telefonu',
        phoneInvalid: 'Numer telefonu jest nieprawidłowy',
        datetime: 'Wybierz datę i godzinę przejazdu',
        license: 'Numer licencji lub numer rejestracyjny jest nieprawidłowy',
        pickup: 'Podaj adres odbioru',
        dropoff: 'Podaj adres docelowy',
        category: 'Wybierz kategorię reklamacji',
        description: 'Opisz zdarzenie',
        descriptionTooShort: 'Opis musi mieć co najmniej 20 znaków',
      },
      auth: {
        loginPage: {
          passwordBlank: 'podaj hasło'
        },
        loginForm: {
          passwordBlank: 'podaj hasło'
        },
        newPassswordAndCode: {
          codeFull: "Proszę wpisać cały kod",
          codeEmpty: 'Proszę wpisać kod'
        },
        emailForm: {
          emailEmpty: "Adres email jest wymagany",
          emailInvalid: "Niepoprawny adres email",
          requestError: "Wystąpił błąd. Spróbuj ponownie."
        },
        customerBasicValidation: {
          nameToShort: "Minimum 3 znaki",
          nameToLong: "Nazwa jest zbyt długa",
          emailInvalid: "Adres email jest niepoprawny",
          passwordToShort5chars: "Minimum 5 znaków",
          passwordToLong: "Hasło jest za długie.",
        },
        customerAddressValidation: {
          latEmpty: "Lat cannot be empty",
          lngEmpty: "Lng cannot be empty",
          streetEmpty: "Pole 'adres' nie może pozostać puste",
          postCodeEmpty: 'Pole "kod pocztowy" nie może być puste',
          typeEmpty: "Type cannot be empty"
        },
        customerPhoneValidation: {
          exactlyLength: "Numer telefonu powinien mieć %size% cyfr",
          minNumbersPre: "Minimum",
          minNumbersPost: "cyfr",
          phoneToLong: "Numer telefonu jest zbyt długi",
          countryCodeEmpty: "Brak numeru kierunkowego"
        },
        registrationFormStep1: {
          emailBusy: "Adres email jest zajęty"
        }
      }
    },
    auth: {
      loginPage: {
        title: "Cześć! Miło znów Cię widzieć.",
        subtitle: "Kontynuuj z",
        authSeparator: "lub",
        passwordLabel: "hasło",
        forgotPassword: "Zapomniałeś hasła?",
        logIn: "Zaloguj się",
        accountInfo: "Nie masz jeszcze konta?",
        createAccount: "Załóż konto",
      },
      newPassswordAndCode: {
        title: 'Zmień hasło',
        codeTitle: 'Wysłaliśmy Ci 4-cyfrowy kod weryfikacyjny.',
        codeSentTo: 'na adres',
        newPasswordLabel: "nowe hasło",
        backToEmail: "Wróć do adresu email",
        changePasswordButton: "Zmień hasło"
      },
      emailForm: {
        title: "Zmień hasło",
        description: "Wpisz swój adres email, wyślemy na niego kod weryfikacyjny.",
        emailLabel: "Adres email",
        remember: "Pamiętam! ",
        goBack: "Wróć",
        resetPasswordButton: "Zmień hasło",
        successMessage: "Pomyślnie zmieniono hasło"
      },
      registrationForm: {
        title: 'Kontynuuj z',
        or: 'lub',
        signUpEmail: 'Zaloguj się przez email',
        haveAccount: 'Masz już konto?',
        logIn: 'Zaloguj się'
      },
      registrationFormStep1: {
        header: 'Miło cię poznać',
        labels: {
          fullname: "Imię i nazwisko",
          email: "email",
          password: "hasło"
        },
        terms: {
          first: "Kontynuując akceptujesz ",
          second: "Regulamin",
          and: "i",
          third: "Politykę prywatności"
        },
        haveAccount: 'Masz juz konto?',
        logIn: 'Zaloguj się'
      },
      registrationFormStep2: {
        linkTitle: "Edytuj dane kontaktowe",
        title: "Prawie gotowe",
        description: "Prosimy, upewnij się, ze numer telefonu jest poprawny.",
        descriptionSms: "Wyślemy Ci kod weryfikacyjny smsem"
      },
      registrationFormStep3: {
        headerLinkTitle: "Edytuj email",
        headerTitle: "Wprowadź kod weryfikacyjny",
        headerDescription: "Wysłaliśmy Ci 4-cyfrowy kod weryfikacyjny na %email%",
        wrongQuestion: "Zły email?",
        change: "Zmień go",
        changeTitle: "Zmień email",
        receiveCodeQuestion: "Nie otrzymałeś kodu?",
        sendAgain: "Wyślij ponownie",
        separator: "albo",
        skipTitle: "pomiń",
        skip: " kontynuuj bez zakładania konta",
        done: "Gotowe"
      }
    },
    userData: {
      backToAddress: "Wróć do adresu",
      backToPersonalData: "Wróć do danych osobowych",
      personalData: "Dane kontaktowe",
      loginForm: {
        accountInfo: "Nie masz konta?",
        register: "Zarejestruj się",
        passwordLabel: "hasło"
      },
      registerForm: {
        accountInfo: "Masz już konto?",
        logIn: " Zaloguj się",
        labels: {
          fullname: "Imię i nazwisko",
          email: "email",
          password: "hasło"
        },
        createAccount: "Chcesz utworzyć konto?",
      },
      changePhoneForm: {
        sendCodeInfo: "Wysłaliśmy Ci 4-cyfrowy kod weryfikacyjny na %phone_label% %phone_number%",
        backToPhone: "Wróć do nr telefonu",
        done: "Gotowe"
      }
    },
    addressItem: {
      deleteTitle: 'Usuń adres',
      deleteQuestion: 'Jesteś pewny, że chcesz usunąć ten adres?',
      confirmButton: 'Tak',
      rejectButton: 'Nie, zachowaj',
      deletePlaceTitle: 'Usuń miejsce'
    },
    account: {
      editProfileTitle: 'Edytuj profil',
      menu: {
        myTrips: 'Moje przejazdy',
        cards: 'Moje karty',
        places: 'Moje miejsca',
        invoices: 'Faktury',
        settings: 'Ustawienia'
      },
      card: {
        deleteCard: 'Usuń kartę',
        deleteCardMessage: 'Czy na pewno chcesz usunąć tę kartę?',
        title: 'Moje karty',
        stripeTitle: 'Bezpieczne płatności przez Stripe',
        addNewCardTitle: 'Dodaj nową kartę',
        cardNumberPlaceholder: 'Numer karty',
        cardDatePlaceholder: 'MM/RR',
        cardCvcPlaceholder: 'CVC',
        addCardButton: 'Dodaj kartę',

        removeBtnConfirm: 'Tak',
        removeBtnCancel: 'Nie, zachowaj',
        chooseCard: 'Wybierz kartę',
        emptyCardsList: 'Nie masz zapisanych żadnych kart.',
        addNewCardButton: 'Dodaj nową kartę',

        addNewOne: 'dodaj nową',
        saveCard: 'Zapisz kartę',
        invoiceInfo: 'Informacje do faktury',
      },
      places: {
        title: 'Moje miejsca',
        myPlaces: 'Miejsca',
        list: {
          favPlacesEmpty: 'Nie masz żadnych zachowanych miejsc.',
          addNewAddress: 'Dodaj nowy adres'
        }
      },
      invoices: {
        invoiceInfo: 'Informacje do faktury',
        invoiceSave: "Zapisz",
        form: {
          companyNameLabel: 'Nazwa firmy',
          addressLabel: 'Adres',
          taxNumberLabel: 'NIP',
          checkboxInfo: 'Faktura dla każdej rezerwacji',
        },
      },
      settings: {
        title: 'Ustawienia',
        notifications: 'Powiadomienia',
        language: 'Język',
        logout: 'Wyloguj',
        langs: {
          en: 'English',
          no: 'Norsk',
          pl: 'Polski',
          ru: 'Русский'
        }
      }
    },
    login: {
      title: 'Panel logowania',
      footer: 'footer'
    },
    sessions: {
      login: {
        title: 'Formularz logowania',
        email: 'Podaj email',
        password: 'Podaj hasło'
      }
    },
    dashboard: {
      myTrips: "Moje przejazdy",
      filterByDate: 'Wybierz datę',
      getInvoice: 'Pobierz fakturę',
      notFoundTrips: "Nie znaleziono rezerwacji",
      upcoming: "Nadchodzące przejazdy",
      payToDriver: 'Zapłać u kierowcy',
      payWithCard: 'Zapłacone kartą',
      notificationButtons: {
        cancelBookingConfirm: "Tak, anuluj rezerwację",
        cancelBookingText: "Nie, zachowaj",
        refundInfo: "Jeśli płaciłeś kartą, pieniądze wrócą na Twoje konto do 10 dni roboczych",
        infoWithoutRefundNotification: "Jeśli płaciłeś kartą, pieniądze wrócą na Twoje konto do 10 dni roboczych",
        editButton: "Edytuj",
        cancel: "Usuń",
        booking: "Rezerwacje",
        cancelBooking: {
          title: "Jesteś pewny, że chcesz anulować rezerwację?",
          message: "%on% z %from% do %to%"
        },
        closeTitle: "Zamknij"
      },
      slider: {
        title: "Jak przebiegła Twoja podróż z %driverName%?",
        desc: "%date% z %from% do %to%",
        content: "Jak przebiegła Twoja podróż? Będziemy wdzięczni za opinie!",
        addReview: "Dodaj recenzję",
        closeReview: "Zamknij recenzję",
        textAreaPlaceholder: "Chcielibyśmy wiedzieć wiecej"
      },
      summary: {
        newPrice: "Nowa cena",
        changePrice: "Zmiana w cenie",
        paySupl: "Zapłać",
        refund: "Do zwrotu",
        oldPrice: "Stara cena",
        changesSaved: "Twoje zmiany zostały zapisane",
        payDriver: "Wybrałeś płatność u kierowcy. W busie możesz zapłacić kartą lub gotówką (NOK).",
        buttonText: "OK"
      }
    },
    invoiceCheckbox: {
      company: "Płaci firma?",
      addInvoice: "Dodaj informacje do faktury",
      canceledInfo: "Twoja prośba o faktutę zostanie anulowana.",
      fillTheForm: {
        first: "Proszę",
        last: " wypełnij cały formularz"
      },
      issueInvoice: "Wystaw fakturę dla ",
      changeInfo: "Potrzebujesz zmienić informacje do faktury?"
    },
    flyOut: 'Wylot',
    flyBack: 'Przylot',
    common: {
      success: "Zapisano",
      error: "Bląd",
      terms: "Regulamin",
      privacyPolicy: "Polityka prywatności",
      logIn: "Zaloguj się",
      signUp: "Załóż konto",
      bookNow: "Zarezerwuj teraz",
      nothingInfo: "Nic tu nie ma",
      nothingMessage: "Twoje rezerwację będą dostępne tutaj.",
      previous: "Poprzedni",
      loggedInError: "Musisz być zalogowany.",
      loggedInMessage: "Witaj ponownie!",
      skipToLogin: "Zaloguj się",
      somethingWrong: "Coś poszło nie tak",
      optional: 'opcjonalne',
      adults: 'dorośli',
      travelersLabel: 'Pasażerowie',
      travelersInput: 'Pasażerowie',
      teenagers: 'Nastolatkowie 13-17',
      students: 'Studenci',
      seniors: 'Seniorzy (67+)',
      kids: 'dzieci',
      under: 'do',
      step: 'krok',
      next: 'Dalej',
      price: 'cena',
      currency: 'nok',
      backToBooking: 'Wróć do rezerwacji',
      backToLogin: 'Wróć do logowania',
      backToProfile: 'Wróć do swojego profilu',
      ok: 'Ok',
      signUpWithEmail: 'Zaloguj się przez email',
      close: 'Zamknij',
      show: 'Pokaż',
      hide: 'Ukryj',
      back: 'Wróć',
      save: 'Zapisz',
      inputs: {
        oldPassword: 'stare hasło',
        newPassword: 'nowe hasło'
      },
      contact: {
        phone: "(+47) 96 70 11 03",
        phoneTitle: "Zadzwoń do nas",
        email: "support@flyo.no",
        emailTitle: "Wyślij nam email"
      }
    },
    calendar: {
      oneWay: 'W jedną stronę',
      confirm: 'Ok'
    },
    bookingStep1: {
      mobile: {
        selectDate: 'Wybierz datę',
        selectDates: 'Wybierz datę',
        selectAirportLabel: 'Wybierz przystanek',
        selectAirportTitle: 'Wybierz przystanek',
      },
      headerChooseAirport: 'Wybierz przystanek',
      header: 'Zarezerwuj transport',
      whatFlight: 'Dokąd jedziesz?',
      chooseAirport: {
        listEmpty: 'Nie znaleziono przystanku, spróbuj ponownie.',
        from: 'Wybierz przystanek z',
        to: 'Wybierz przystanek do',
      },
      chooseAirportPlaceholder: 'Wybierz przystanek..',
      chooseAirportFrom: 'Z',
      chooseAirportTo: 'Do',
      chooseSelectDate: 'Wybierz datę',
      chooseSelectDatePlaceholder: 'Wyświetl kalendarz',
      letsGo: 'Jedźmy!',
      errors: {
        date: 'Wybierz datę',
        busStop: 'Wybierz przystanek',
        passengers: 'Wybierz ilość pasażerow'
      }
    },
    kidsSafety: {
      labels: {
        firstAge: '0-15 miesięcy',
        firstWeight: '0-13kg',
        secondAge: '1-4 lat',
        secondWeight: '9-18kg',
        thirdAge: '4-12 lat',
        thirdWeight: '15-36kg',
        fourthAge: '4+ lat',
        fourthWeight: '15-36kg',
      },
      title: 'Foteliki bezpieczeństwa',
      tripWithCount: 'Jedziesz z ',
      tripWithCountSufix: ' dzieci.',
      typeOfSeatsQuestion: 'Jakich fotelików potrzebujesz?',
      safetyList: {
        chooseTitle: 'Musisz wybrać ',
        chooseTitleSufix: ' więcej',
        items: {
          cradle: 'Kołyska',
          seatWithSeatBelts: 'Siedzący z pasami',
          seatWithoutSeatBelts: 'Siedzący bez pasów',
          carSeatPad: 'Podkładka',
          noNeedCarSeat: 'Nie potrzebuję fotelika'
        }
      }
    },
    bookingStep2: {
      chooseFlyOut: 'Wylot',
      chooseFlyBack: 'Przylot',
      editKids: 'Edytuj foteliki',
      errors: {
        flight: {
          departure: 'Musisz wybrać przejazd',
          return: 'Musisz wybrać przejazd'
        }
      }
    },
    // map
    bookingStep3: {
      map: {
        backToSelectFlight: 'Wróć do wyboru lotu',
        addAddress: {
          first: 'Dodaj ',
          second: ' inny ',
          third: ' adres powrotny'
        },
        removeReturnAddress: 'Usuń adres powrotny',
        addToFav: "Dodaj do ulubionych"
      },
      address: {
        inputPlaceholder: 'Wpisz adres zamieszkania lub wybierz przystanek autobusowy'
      },
      favButton: 'Dodaj do ulubionych',
      favSpotButton: 'Zapisz jako:',
      spots: {
        home: 'Dom',
        work: 'Praca',
        other: 'Inne'
      },
      summary: {
        from: 'z',
        to: 'do',
        totalPrice: 'Cena końcowa',
        smsInfoFirst: 'Dzień przed odlotem wyślemy Ci smsa',
        smsInfoSecond: 'z godziną przyjazdu kierowcy.',
        tooltip: {
          button: 'Więcej informacji',
          departures: 'Rozkład jazdy busów Flyo jest powiązany z godzinami odlotów i przylotów. Jeśli zmieni się godzina lotu, nasz rozkład ulegnie zmianie.',
          arrivals: 'Bus odjeżdża najwcześniej 30 minut po faktycznym przylocie do Torp.',
        }
      },
      errors: {
        postCode: 'Brak kodu pocztowego.',
        street: 'Brak numeru domu.',
        coords: 'Nie znaleziono współrzędnych dla wybranego adresu.',
        addressNotFound: 'Nie znaleziono adresu.',
        connection: 'Zerwane połączenie z serwerem', // general info when something is wrong with connection ...
        addressNotSupported: 'Adres nie jest obsługiwany.',
        selectAddress: 'Proszę, wybierz adres.'
      }
    },
    //summary
    bookingStep4: {
      stepHeader: {
        title: 'Podsumowanie rezerwacji',
        linkTitleAddressSelection: 'Wróć do wyboru adresu',
        linkTitleUserSelection: 'Wróć do sekcji użytkownik'
      },
      summary: {
        selectCity: 'Przylot z',
        selectCityPlaceholder: 'Wybierz miasto',
        otherCity: 'Inne',
        title: 'Podsumowanie',
        totalPrice: 'Cena',
        bookNow: 'Zarezerwuj',
        payToDriver: 'Zapłać u kierowcy',
        payUsingCard: 'Zapłać kartą'
      },
      address: {
        return: 'Powrót: ',
        departure: 'Odlot: '
      },
      errors: {
        emptyCity: 'Wybierz miasto',
        payment: {
          emptyData: 'Brak danych. Uzupełnij proces rezerwacji aby kontynuować',
          selectPaymentMethod: 'Wybierz sposób płatności',
          cardDetails: 'Wprowadź dane karty płatniczej',
          paymentFailed: 'Wystąpił błąd podczas płatności'
        },

        map: {
          addressNotSupported: ' Adres nie jest obsługiwany',
          addressEmpty: 'Nie wybrano adresu',
          addressPostalCode: 'Przepraszamy! Nie jeździmy pod ten kod pocztowy.',
          streetNumber: 'Brak numeru ulicy',
          streetCoords: 'Nie znaleziono współrzędnych dla ulicy',
        }
      }
    },
    bookingStepFinal: {
      title: 'Dziękujemy za podróż z nami',
      info: {
        first: 'Twoja rezerwacja została wysłana',
        second: 'Możesz edytować swoją rezerwację do godziny 18.00 jeden dzień przed wyjazdem.',
        third: 'Jeśli masz pytania, skontaktuj się z nami.'
      },
      confirm: 'Ok'

    },
    homepage: {
      title: 'PROSTY DOJAZD NA LOTNISKO',
      content: `Wybierz lot do lub z lotniska Oslo Sandefjord Torp,
       a nastęonie zarezerwuj bus telefonicznie lub na stronie internetowej.
       Odbierzemy Cię z domu, pracy lub lotniska
       Otrzymasz od nas smsa z godziną przyjazdu busa dzień przed planowanym lotem.
       Będziemy również dzwonić na chwilę przed przyjazdem pod wskazany adres`
    },
    prices: {
      title: 'Ceny transportu lotniskowego',
      content: 'Skorzystaj z najlepszych cen transferu lotnisko do i z lotniska Oslo Torp'
    },
    help: {
      header: 'Pomoc',
      question: 'Masz jakieś pytania odnośnie naszego serwisu?',
      checkLink: 'Sprawdź linki poniżej lub skontakuj się z nami.',
      officeWorks: 'Nasze biuro pracuje od poniedziałku do piątku.',
      rightsReserved: '© 2024 Flyo AS. All rights reserved.'
    }
  },
  routes: {
    url: {
      booking: '/:locale/booking',
      kidsSafety: '/:locale/booking/kids-safety',
      flights: '/:locale/booking/flight',
      map: '/:locale/booking/map',
      userData: '/:locale/booking/user-data',
      confirmPhone: '/:locale/booking/confirm-phone',
      summary: '/:locale/booking/summary',
      confirmed: '/:locale/booking/confirmed',
      signup: '/:locale/signup',
      registrationStep1: '/:locale/registration-step-1',
      registrationStep2: '/:locale/registration-step-2',
      registrationStep3: '/:locale/registration-step-3',
      login: '/:locale/login',
      resetPassword: '/:locale/reset-password',
      dashboard: '/:locale/dashboard',
      dashboardEdit: '/:locale/dashboard/edit/:id',
      dashboardReservationPayment: '/:locale/dashboard/reservation-payment',
      help: '/:locale/help',
      accountTrips: '/:locale/account/my-trips',
      account: '/:locale/account',
      accountProfile: '/:locale/account/profile',
      accountCards: '/:locale/account/cards',
      accountPlaces: '/:locale/account/places',
      accountPlacesMap: '/:locale/account/map',
      accountInvoices: '/:locale/account/invoices',
      accountSettings: '/:locale/account/settings',

      home: '/pl',
      howItWorks: '/:locale/jak-dzialamy',
      prices: '/:locale/cennik',
      hortenTorp: '/:locale/bus-lotniskowy-horten-torp',
      complaint: '/:locale/reklamacja',
      faq: '/:locale/pytania-i-odpowiedzi',
      contact: '/:locale/kontakt',
      termsAndConditions: '/:locale/regulamin',
      privacyPolicy: '/:locale/polityka-prywatnosci',
    },
    name: {
    }
  },
  test: { test: "hello" },
  errors: {
    notFound: {
      title: "404",
      content: "Ups! Nie mogliśmy znaleźć strony, której szukasz."
    }
  }
}
